
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class ScrollToController extends Controller {

	static values = {
		selector: String
	};

	/**
	* I get called whenever this instance is bound to a host element.
	*/
	connect() {

		var target = ( this.hasSelectorValue )
			? document.querySelector( this.selectorValue )
			: this.element
		;

		if ( target ) {

			target.scrollIntoView();

		}

	}

}
